import { put, takeLatest } from 'redux-saga/effects';
import { Action } from 'redux';
import { notify } from './actions';
import { createProjectSuccess, saveProjectSuccess } from '../projects/actions';
import { createOrganizationSuccess, saveOrganizationSuccess } from '../organizations/actions';
import { createVideoSuccess, saveVideoSuccess } from '../videos/actions';
import { createCustomerSuccess, saveCustomerSuccess } from '../customers/actions';
import { createUserSuccess, saveCurrentUserSuccess, saveUserSuccess } from '../users/actions';
import { createVideoMenuSuccess, saveVideoMenuRequest } from '../video-menus/actions';
import { createActionTypeToResource } from '../../../utility/string';

function* saveRecord() {
  yield put(notify({
    type: 'success',
    message: 'Change saved',
  }));
}

function* createRecord(action: Action) {
  const resource = createActionTypeToResource(action.type);

  yield put(notify({
    type: 'success',
    message: `${resource} created`,
  }));
}

export default [
  takeLatest([
    saveProjectSuccess.type,
    saveOrganizationSuccess.type,
    saveVideoSuccess.type,
    saveCustomerSuccess.type,
    saveUserSuccess.type,
    saveVideoMenuRequest.type,
    saveCurrentUserSuccess.type,
  ], saveRecord),

  takeLatest([
    createUserSuccess.type,
    createProjectSuccess.type,
    createOrganizationSuccess.type,
    createVideoSuccess.type,
    createCustomerSuccess.type,
    createVideoMenuSuccess.type,
  ], createRecord),
];
